import Joi from 'joi';
import schemas from 'components/forms/fields/definedSchemas';

const fields = {
    ssl_type: {
        ...schemas.textRequired,
        section: 'Signature',
        initialValue: 'noaatoss',
        hidden: true,
    },
    official_letterhead: {
        ...schemas.boolRequiredTrue,
        section: 'Signature',
        label: 'Is your Transcript of Sea Service on NOAA official letterhead?',
        validation: schemas.boolRequiredTrue.validation.messages({
            'any.invalid': 'Form must be on NOAA official letterhead.',
        }),
    },
    document_signed: {
        ...schemas.boolRequiredTrue,
        section: 'Signature',
        label: 'Is your Transcript of Sea Service signed by an authorized representative?',
        validation: schemas.boolRequiredTrue.validation.messages({
            'any.invalid': 'Form must be signed.',
        }),
    },
    date_document_signed: {
        ...schemas.dateRequiredMaxToday,
        section: 'Signature',
        label: 'What is the date on the TOSS?',
    },
    vessel_name: {
        ...schemas.textRequired,
        section: 'Vessel',
        label: 'Vessel Name',
    },
    imo_number: {
        ...schemas.imoRequired,
        section: 'Vessel',
        label: 'IMO',
    },
    vessel_type: {
        ...schemas.radioRequired,
        section: 'Vessel',
        label: 'Type of Vessel',
        options: {Motor: 'Motor', Sail: 'Sail'},
    },
    tonnage: {
        ...schemas.floatRequired,
        section: 'Vessel',
        label: 'Tonnage',
    },
    tonnage_type: {
        ...schemas.tonnageTypeRequiredToss,
        section: 'Vessel',
        label: 'What type of tonnage is used on this form?',
    },
    length_tonnage: {
        ...schemas.floatRequired,
        section: 'Vessel',
        label: 'Length',
    },
    engine_horsepower: {
        ...schemas.floatRequired,
        section: 'Vessel',
        label: 'Horsepower',
    },
    date_reported: {
        ...schemas.dateRequiredMaxToday,
        section: 'ShipmentAndDischarge',
        label: 'Date Reported',
    },
    date_detached: {
        ...schemas.dateRequiredMaxToday,
        section: 'ShipmentAndDischarge',
        label: 'Date Detached',
        validation: schemas.dateRequiredMaxToday.validation
            .min(Joi.ref('date_reported'))
            .messages({
                'date.min': "End date can't be before start date.",
                'date.max': 'Dates in the future not allowed.',
            }),
    },
    deck_position_served: {
        ...schemas.selectRequired,
        section: 'ShipmentAndDischarge',
        label: 'Deck Position Served',
        options: {
            'Officer of the Deck (OOD)': 'Officer of the Deck (OOD)',
            'Junior Officer of the Deck (JOOD)': 'Junior Officer of the Deck (JOOD)',
            'Commanding Officer (CO)': 'Commanding Officer (CO)',
            'Executive Officer (XO)': 'Executive Officer (XO)',
            SWO: 'SWO',
            'Operations Officer': 'Operations Officer',
            'Operations Officer in Training': 'Operations Officer in Training',
            Training: 'Training',
            'Augmenting OOD': 'Augmenting OOD',
            'SWO Instructor': 'SWO Instructor',
        },
    },

    department: {
        section: 'ShipmentAndDischarge',
        initialValue: 'deck',
        validation: Joi.string(),
        required: true,
    },
};

export default fields;
